import { Button, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { MdmTable } from "src/components/MdmTable";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { ZFilterTemplate } from "../../types";
import { queryBuilderTemplatesColumns } from "./queryBuilderTemplatesColumns";

interface PropsQueryBuilderTemplatesModal {
  open: boolean;
  canSelectTemplate: boolean;
  tableStore: RtStore<ZFilterTemplate, {}>;
  onSelect: () => void;
  onDelete: (id: string) => void;
  onClose: () => void;
}

export const QueryBuilderTemplatesModal: React.FC<PropsQueryBuilderTemplatesModal> =
  observer(
    ({ open, canSelectTemplate, tableStore, onSelect, onClose, onDelete }) => {
      const [modal, contextHolder] = Modal.useModal();

      const handleDelete = (row: ZFilterTemplate) => {
        modal.confirm({
          title: "Удалить данные?",
          content: `Шаблон "${row.name}" будет удален`,
          okText: "Удалить",
          cancelText: "Отменить",
          onOk: () => onDelete?.(row.id),
        });
      };

      const columns = React.useMemo(
        () =>
          queryBuilderTemplatesColumns({
            onDelete: handleDelete,
          }),
        [onDelete],
      );

      return (
        <>
          {contextHolder}
          <Modal
            zIndex={900}
            width={900}
            open={open}
            onCancel={onClose}
            title="Шаблоны фильтров"
            closable
            centered
            styles={{
              body: {
                height: "calc(100vh - 300px)",
              },
            }}
            footer={
              <Button
                disabled={!canSelectTemplate}
                type="primary"
                onClick={onSelect}
              >
                Выбрать
              </Button>
            }
          >
            <MdmTable
              store={tableStore}
              columns={columns}
              showTotal={(count) => `Всего: ${count}`}
              showSizeChanger
            />
          </Modal>
        </>
      );
    },
  );
